var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0582 41.8813C32.7138 39.909 33.9737 38.1933 35.6592 36.9774C37.3447 35.7614 39.3703 35.107 41.4486 35.107C43.8177 35.107 45.6297 35.7388 47.5423 37.4043L52.3609 32.6919C50.4683 31.0138 48.2142 29.7948 45.7738 29.1295C43.3334 28.4642 40.7724 28.3705 38.29 28.8559C35.8075 29.3412 33.4704 30.3924 31.4602 31.9278C29.4501 33.4632 27.821 35.4414 26.6997 37.7087L32.0582 41.8813Z",
    fill: "#DD4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0613 48.1271C31.3893 46.0994 31.3893 43.909 32.0613 41.8813L26.6999 37.7087C25.5816 39.9766 25 42.4713 25 44.9999C25 47.5285 25.5816 50.0232 26.6999 52.2911L32.0613 48.1271Z",
    fill: "#F1B71A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7032 42.0622H41.3369V48.4832H50.1414C49.971 49.4879 49.5906 50.4453 49.025 51.2929C48.4594 52.1406 47.7214 52.8594 46.8591 53.4024L52.0942 57.4802C55.7268 54.1749 57.8088 48.9111 56.7032 42.0622Z",
    fill: "#4779BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4486 61.4489C45.3664 61.4922 49.1605 60.0777 52.0939 57.4802L46.8588 53.4025C45.5748 54.1923 44.1298 54.6839 42.6305 54.8412C41.1312 54.9984 39.6158 54.8173 38.1958 54.3111C36.7758 53.8048 35.4875 52.9865 34.4257 51.9162C33.364 50.846 32.556 49.5512 32.0611 48.1272L26.6997 52.2911C28.0598 55.0409 30.1617 57.3556 32.7679 58.9738C35.3741 60.592 38.3809 61.4493 41.4486 61.4489Z",
    fill: "#37A052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupGoogle);
export default __webpack_public_path__ + "static/media/signup_google.1828f68896fae75567db6a2ac4f98280.svg";
export { ForwardRef as ReactComponent };